import React from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';


const DeleteTechnicianModal = ({
    errors,
    isLoading,
    close,
    toggleLoading,
    clearErrors,
    open,
    selectedTechnician,
    title,
    ...props
}) => {

    const handleDelete = async () => {
        const {
            deleteTechnician,
            setSelectedTechnician,
            fetchTechniciansList
        } = props;

        let isDeleted;

        if (!isLoading) {
            toggleLoading(true);
            isDeleted = await deleteTechnician(selectedTechnician.id);
        }

        handleClose();

        if (isDeleted) {
            setSelectedTechnician(null);
            await fetchTechniciansList();
        }
    };

    const handleClose = () => {
        clearErrors();
        toggleLoading(false);
        close();
    };

    if (!selectedTechnician) return null;

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={handleClose}
            title={title}
            onConfirm={handleDelete}
            isLoading={isLoading}
            confirmText="Delete"
        >
            <p>
                Are you sure you want to delete Technician: {selectedTechnician.name}?
            </p>
        </EsmsDialog>
    );
};

DeleteTechnicianModal.propTypes = {
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = state => {
    return {
        errors:             state.messages.errors,
        isLoading:          state.ui.isLoading,
        selectedTechnician: state.architect.selectedTechnician
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteTechnicianModal);
